import { render, staticRenderFns } from "./BusinessPlanLog.vue?vue&type=template&id=06d2d91c&scoped=true"
import script from "./BusinessPlanLog.vue?vue&type=script&lang=js"
export * from "./BusinessPlanLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d2d91c",
  null
  
)

export default component.exports